function findNearestDataValue(event, attrName) {
  let elem = event.target;

  while (elem) {
    if (elem.dataset[attrName]) {
      return elem.dataset[attrName];
    }
    elem = elem.parentNode;
  }
  return null;
}

export function findZipcode(e) {
  return findNearestDataValue(e, 'zipcode');
}

export function findProdcode(e) {
  return findNearestDataValue(e, 'prodcode');
}

export function validateEmail(value) {
  let regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i;
  if (!regex.test(value.replace(/\s/g, ''))) {
    return false;
  }
  return true;
}

export function genderPercentage(femaleAudience, maleAudience, otherAudience) {
  const maxAvgGender =
    Math.max(femaleAudience, maleAudience, otherAudience) || 1;

  femaleAudience = Number((femaleAudience / maxAvgGender) * 100).toFixed(1);
  maleAudience = Number((maleAudience / maxAvgGender) * 100).toFixed(1);
  otherAudience = Number((otherAudience / maxAvgGender) * 100).toFixed(1);
  return [femaleAudience, maleAudience, otherAudience];
}

export function scrollToSection(sectionId) {
  document.getElementById(sectionId).scrollIntoView(true);
}
